/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React from "react";

interface NoReultsFoundProps {
  keyword?: string;
}

function NoResultsFound({ keyword }: NoReultsFoundProps) {
  return (
    <div className="container">
      <div className="card border-0 bg-light p-5 mt-4 text-center">
        <i className="fas fa-search fa-2x"></i>
        {keyword ? (
          <p>No Search Results Found for "{keyword}"</p>
        ) : (
          <p>No Search Results Found</p>
        )}
      </div>
    </div>
  );
}

export default NoResultsFound;
